<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <HelloWorld msg="Welcome to Your Vue.js App" />
 
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";


export default {
  name: "App",
  components: {
    HelloWorld,
  },
  data() {
    return {
      feishuCode: "",
      resData:''
    };
  },
  created() {
   
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.code-box {
  margin-top: 20px;
}
.code-text {
  display: inline-block;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 4px;
  word-break: break-all;
}
</style>
